import { ref, watch, computed } from '@vue/composition-api'
import store from '@/store'
import { title } from '@core/utils/filter'

// Notification
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import ability from '@/libs/acl/ability'

export default function useQuotationsList() {

    
    //User toast
    const toast = useToast()

    const refQuotationListTable = ref(null)

    const tableColumns = [
        {key: 'quotation_number',stickyColumn: true, label:'QUOTATION NUMBER', sortable: true},
        {key: 'client', sortable:true},
        {key: 'client_name', label:'CLIENT NAME', sortable: true},
        {key: 'contract'},
        {key: 'project'},
        {key: 'total_amount', label:'AMOUNT(HK$)', sortable: true},
        {key: 'created_by'},
        {key: 'quotation_date', label:'QUOTATION DATE', sortable: true},
        {key: 'total_amount', label:'AMOUNT(HK$)', sortable: true},
        {key: 'export', label:'Quotation', sortable: true},
        {key: 'actions'},
    ]

    //Filter
    const userFilter = ref(null)
    const clientFilter = ref(null)
    const dateFromFilter = ref(null)
    const dateToFilter = ref(null)
    const deleteFilter = ref(null)

    const perPage = ref(10)
    const totalQuotations = ref(0)
    const currentPage = ref(1)
    const perPageOptions = [10, 25, 50, 100]
    const searchQuery = ref('')
    const sortBy = ref('id')
    const isSortDirDesc = ref(true)

    const dataMeta = computed(() => {
        const localItemsCount = refQuotationListTable.value ? refQuotationListTable.value.localItems.length : 0
        return {
            from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
            to: perPage.value * (currentPage.value - 1) + localItemsCount,
            of: totalQuotations.value,
        }
    })

    const refetchData = () => {
        refQuotationListTable.value.refresh()
    }

    watch([currentPage, perPage, searchQuery, userFilter, clientFilter, dateFromFilter, dateToFilter,deleteFilter], () => {
        refetchData()
    })

    const fetchQuotations = (ctx, callback) => {
        store.dispatch('quotation/fetchQuotations',{
            q: searchQuery.value,
            perPage: perPage.value,
            page: currentPage.value,
            sortBy: sortBy.value,
            sortDesc: isSortDirDesc.value,
            create_id: userFilter.value,
            client_id: clientFilter.value,
            date_from: dateFromFilter.value,
            date_to: dateToFilter.value,
            is_deleted: deleteFilter.value
        })
        .then(response =>{
            const {quotations, total} = response.data
            callback(quotations)
            totalQuotations.value = total
        
        })
        .catch((error) => {
            console.log(error)
            toast({
                component: ToastificationContent,
                props: {
                    title: 'Error fetching quotation list',
                    icon: 'AlertTriangleIcon',
                    variant: 'danger'
                }
            })
        })
    }

    return {
        fetchQuotations,
        tableColumns,
        perPage,
        currentPage,
        totalQuotations,
        dataMeta,
        perPageOptions,
        searchQuery,
        sortBy,
        isSortDirDesc,
        refQuotationListTable,
        ability,
        refetchData,
        userFilter,
        clientFilter,
        dateFromFilter,
        dateToFilter,
        deleteFilter,
    }

}